import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../apiBase';
import { useAuth } from '../context/AuthContext';

export default function useOwnPlayerAccess() {
  const { user, accountSummary } = useAuth();
  const identity = `${user?.id || user?.email || ''}:${user?.role || ''}`;
  const modules = accountSummary?.modules;
  const eligible = ['admin', 'reseller'].includes(user?.role) &&
    (user?.role === 'admin' || (Array.isArray(modules) && (modules.includes('*') || modules.includes('clients'))));
  const [state, setState] = useState(null);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setState(null);
    if (eligible) axios.get(`${API_BASE_URL}/api/player-app/access`, { withCredentials: true })
      .then(({ data }) => { if (active) setState({ identity, status: data?.can_personalize === true ? 'allowed' : 'denied', pilot: data?.pilot === true }); })
      .catch(() => { if (active) setState({ identity, status: 'error' }); });
    return () => { active = false; };
  }, [identity, eligible, attempt]);
  const current = state?.identity === identity ? state : null;
  return { status: !eligible ? 'denied' : current?.status || 'loading', pilot: current?.pilot === true,
    retry: () => setAttempt(value => value + 1) };
}
